// Excel-style column headers: the pure half. Each column reads a display value
// off a row (what the checklist shows and the filter matches) and optionally a
// separate sort value (an ISO date sorts right where its "3 Oct" label would not).
const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base'
});
/** Rows whose value in every filtered column is ticked, then sorted (stable). No sort keeps the input order. */ export function applyColumnView(rows, specs, filters, sort) {
    const active = specs.filter((s)=>filters[s.id]?.size);
    const kept = active.length ? rows.filter((r)=>active.every((s)=>filters[s.id].has(s.value(r)))) : [
        ...rows
    ];
    const spec = sort && specs.find((s)=>s.id === sort.id);
    if (!sort || !spec) return kept;
    const key = spec.sortValue ?? spec.value;
    const sign = sort.dir === 'asc' ? 1 : -1;
    return kept.sort((a, b)=>sign * collator.compare(key(a), key(b)));
}
/** Every distinct value in the column, in the column's own sort order. */ export function distinctValues(rows, spec) {
    const key = spec.sortValue ?? spec.value;
    const byValue = new Map();
    for (const r of rows){
        const v = spec.value(r);
        if (!byValue.has(v)) byValue.set(v, key(r));
    }
    return [
        ...byValue.entries()
    ].sort((a, b)=>collator.compare(a[1], b[1])).map(([v])=>v);
}
